<template>
  <v-card>
    <div v-if="notification.init === 1">
      <div class="pa-2">
        <v-layout row>
          <v-flex>
            <h4>Notifications</h4>
          </v-flex>
          <v-flex class="text-xs-right">
            <a href="#" @click="doPromptAllRead">Mark All as Read</a>
            -
            <router-link :to="{ name: 'commsSettings' }">
              Settings
            </router-link>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
      <v-container class="scroll-y notificationPnl" id="notificationPnl">
        <v-card-text v-if="notificationCount === 0">
          <v-layout align-center justify-center column>
            You do not have notification
          </v-layout>
        </v-card-text>
        <div v-else v-scroll:#notificationPnl="notificationScroll">
          <v-list three-line>
            <template v-for="(notification, index) in notifications">
              <div :key="notification.id">
                <v-list-tile avatar @click="triggerNotification(index)">
                  <v-list-tile-avatar>
                    <v-icon :class="notification.defMsg.toLocaleLowerCase().includes('error') ? 'error lighten-1 white--text' : 'grey lighten-1 white--text'">{{getIcon(notification.type)}}</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ getTitle(notification.type) }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ notification.defMsg }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>~ {{ formatDisplayTimeDistance(notification.createdDate) }} ago</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon v-if="notification.read" color="primary">mdi-check-all</v-icon>
                    <v-icon v-else color="grey">mdi-check</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < notifications.length"></v-divider>
              </div>
            </template>
            <v-list-tile v-if="$store.state.user.notification.loadingNewNotification">
              <v-list-tile-content>
                <v-list-tile-title class="text-xs-center">
                  <v-progress-circular indeterminate color="primary" :size="15"></v-progress-circular>
                  Loading...
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
      </v-container>
      <confirm v-model="promptAllRead" @ok="flagAllRead">
        Are you sure you want to mark all Notifications as Read?
      </confirm>
    </div>
    <div v-else class="notificationMiscPnl">
      <loader :card="false" :height="200" :init="doReinitMainNotification" loadText="Loading Notifications..." errorText="Error loading Notifications" :loading="notification.init === 0"></loader>
    </div>
    <sys-message v-model="sysMessage" :notification="activeNotification"></sys-message>
  </v-card>
</template>

<script>
import { USER_NOTIFICATION_UNFLAGNEW, USER_NOTIFICATION_FLAGREAD, USER_NOTIFICATION_FLAGALLREAD } from '@/store/types'
import { formatDisplayDateTime, formatDisplayTimeDistance } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { notifyTypes } from '@/const'
import { appIcon } from '@/const/underwriting'
import { sysMessage } from './sysMessage'
import { motorProposalStatus } from './motorProposalStatus'

export default {
  data() {
    return {
      promptAllRead: false,
      activeNotification: undefined
    }
  },
  computed: {
    notification() {
      return this.$store.state.user.notification
    },
    notificationCount() {
      if (this.notifications !== undefined) {
        return this.notifications.length
      } else {
        return 0
      }
    },
    notifications() {
      return this.notification.notifications
    }
  },
  watch: {
    'notificationOpen': function (value) {
      if (value === true) {
        // Unflag new notification if needed
        if (this.notification.newCount > 0) {
          this.unflagNew()
        }
      }
    }
  },
  methods: {
    doReinitMainNotification() {
      this.$store.dispatch('initNotification')
    },
    async unflagNew() {
      // No matter if the server contact pass or fail, we will flag all as unread 1st (responsiveness perception)
      this.$store.commit(USER_NOTIFICATION_UNFLAGNEW)

      const apiUrl = this.notification.menu.unflagNew
      if (apiUrl) {
        try {
          await this.$http.post(apiUrl)
        } catch (error) { }
      }
    },
    async flagRead(index) {
      // Same as unflagNew
      this.$store.commit(USER_NOTIFICATION_FLAGREAD, index)

      const apiUrl = this.notification.menu.flagRead
      const expand = {
        id: this.notifications[index].id
      }
      if (apiUrl) {
        try {
          await this.$http.post(expandURI(apiUrl, expand))
        } catch (error) { }
      }
    },
    doPromptAllRead() {
      this.promptAllRead = true
    },
    async flagAllRead() {
      this.$store.commit(USER_NOTIFICATION_FLAGALLREAD)

      const apiUrl = this.notification.menu.flagAllRead
      if (apiUrl) {
        try {
          await this.$http.post(apiUrl)
        } catch (error) { }
      }
    },
    formateDateTime(time) {
      return formatDisplayDateTime(time)
    },
    formatDisplayTimeDistance(time) {
      return formatDisplayTimeDistance(time)
    },
    triggerNotification(index) {
      this.flagRead(index)

      this.activeNotification = this.notifications[index]
      if (this.activeNotification) {
        // Execute notification action based on types
        if (this.activeNotification.type === 'SYS_MESSAGE') {
          this.doSysMessage()
        } else if (this.activeNotification.type === 'MOTORPROPOSAL_STATUS') {
          this.doMotorProposalStatus(this.activeNotification)
        }
      }
    },
    getTitle(notificationType) {
      if (notifyTypes[notificationType]) {
        return notifyTypes[notificationType]
      }
      return 'Notification'
    },
    getIcon(notificationType) {
      if (notificationType === 'SYS_MESSAGE') {
        return 'mdi-settings'
      } else if (notificationType === 'MOTORPROPOSAL_STATUS') {
        return appIcon.MOTOR
      } else if (notificationType === 'TRVPROPOSAL_STATUS') {
        return appIcon.TRAVEL
      } else if (notificationType === 'FIREPROPOSAL_STATUS') {
        return appIcon.FIRE
      } else if (notificationType === 'CARGOPROPOSAL_STATUS') {
        return appIcon.CARGO
      } else if (notificationType === 'MAIDPROPOSAL_STATUS') {
        return appIcon.MAID
      } else if (notificationType === 'PKGPROPOSAL_STATUS') {
        return appIcon.PACKAGE
      } else if (notificationType === 'CLAIM_STATUS') {
        return 'mdi-cash-usd'
      }
      return 'mdi-folder'
    },
    notificationScroll(e) {
      const scrollHeight = e.target.scrollHeight - e.target.offsetHeight
      // Load when is 100px off the bottom
      const heightToLoad = scrollHeight - 100
      const scrollTop = e.target.scrollTop
      if (scrollTop >= heightToLoad) {
        this.$store.dispatch('loadMoreNotification')
      }
    }
  },
  mounted() {
    if (this.notificationOpen === true) {
      if (this.notification.newCount > 0) {
        this.unflagNew()
      }
    }
  },
  props: ['notificationOpen'],
  mixins: [sysMessage, motorProposalStatus]
}
</script>

<style lang="scss">
.notificationPnl {
  max-height: 600px;
  width: 450px;
  &.container {
    padding: 0px;
  }
}
.notificationMiscPnl {
  padding-top: 50px;
  width: 450px;
}
</style>
